/**
 * Created by eliasmj on 30/01/2015.
 */
angular.module('qkr').service('sessionService', function($cookieStore, $window, $log) {
    const getSessionStorage = () => {
        try {
            return $window.sessionStorage;
        } catch (e) {
            $log.warn('Problem to set storage, storage not available', e);
        }
    };

    const sessionStorage = getSessionStorage();

    const storeValue = (key, value) => {
        // there is some safari version bugged, if fail print warning
        if (value) {
            if (typeof value === 'object') {
                sessionStorage.setItem(key, JSON.stringify(value));
            } else {
                sessionStorage.setItem(key, value);
            }
        } else {
            sessionStorage.removeItem(key);
        }
    };

    this.setCookie = function(name, value) {
        $cookieStore.put(name, value);
    };

    this.getCookie = function(name) {
        return $cookieStore.get(name);
    };

    this.setLastUrlVisited = (value) => {
        storeValue('lastUrlVisited', value);
    };

    this.getLastUrlVisited = () => {
        return sessionStorage.getItem('lastUrlVisited');
    }

    this.setMerchantIdSession = (value) => {
        storeValue('merchantSession', value);
    };

    this.getMerchantSessionId = () => {
        return sessionStorage.getItem('merchantSession');
    }
});




// WEBPACK FOOTER //
// ./src/services/session.service.js